<template>
  <v-app toolbar>
    <v-dialog v-model="info" fullscreen @click.native.stop="info = !info">
      <v-card class="infoDialog">
        <div class="menuIns">
          <v-icon dark>ion-navicon</v-icon>
          <v-icon dark>ion-ios-browsers-outline</v-icon>
        </div>
        <div class="menuInsTip"> <br>
          <strong>Contents</strong><br>
          <small>Navigate to book chapters</small>
        </div>
        <div class="menuInsTip2"> <br>
          <strong>Related Books</strong><br>
          <small>Other books you might like</small>
        </div>
        <div class="socMenu">
          <v-icon dark>ion-social-linkedin</v-icon>
          <v-icon dark>ion-social-facebook</v-icon>
          <v-icon dark>ion-social-twitter</v-icon>
          <v-icon dark>ion-social-tumblr</v-icon>
          <v-icon dark>ion-social-pinterest</v-icon>
        </div>
        <div class="socMenuMob">
          <v-icon>ion-android-share-alt</v-icon>
        </div>
        <div class="socMenuTip"> <br>
          <strong>Share Book</strong><br>
          <small>Share book to your social network</small>
        </div>
        <div class="resize-settings">
          <v-icon>ion-ios-gear-outline</v-icon>
        </div>
        <div class="resize-settings-tip"> <br>
          <strong>Settings button</strong><br>
          <small>Change colors and fonts</small>
        </div>
        <div class="left-button">
          <v-icon dark>ion-ios-arrow-left</v-icon>
        </div>
        <div class="left-button-tip"> <br>
          <strong>Left/Previous</strong><br>
          <small>Go to previous page or chapter in book view.<br>On touch screen swipe right.</small>
        </div>
        <div class="right-button">
          <v-icon dark>ion-ios-arrow-right</v-icon>
        </div>
        <div class="right-button-tip"> <br>
          <strong>Right/Next</strong><br>
          <small>Go to next page or chapter in book view.<br>On touch screen swipe left.</small>
        </div>
        <div class="buy-buttons">
          <v-icon dark>ion-bag</v-icon>
        </div>
        <div class="buy-buttons-mob">
          <v-icon>ion-bag</v-icon>
        </div>
        <div class="buy-buttons-tip"> <br>
          <strong>Buy Book</strong><br>
          <small>Click to stores where you can buy this book</small>
        </div>
        <div class="headline">Instructions</div>
        <v-btn flat class="closeDialog" @click.native.stop="info = false" :ripple="false">Close</v-btn>
      </v-card>
    </v-dialog>
    <v-navigation-drawer class="menu" temporary hide-overlay @click.native.stop="drawer = !drawer" clipped v-model="drawer" enable-resize-watcher disable-route-watcher touchless>
      <v-list>
        <v-list-tile v-for="item in items" v-bind:href="item.path" :key="item.name" :to="item.path" exact :ripple="false" width="100%">
          <v-list-tile-action>
            <img height="55px" v-bind:alt="item.alt" :src="item.image">
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title active>{{ item.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer class="otherBooks" temporary hide-overlay @click.native.stop="otherBooks = !otherBooks" clipped v-model="otherBooks" enable-resize-watcher disable-route-watcher touchless>
      <v-list>
        <h6>Other books you might like:</h6>
        <v-list-tile v-for="book in books" v-bind:href="book.url" :key="book.title" target="_blank" :ripple="false" width="100%">
          <v-list-tile-action>
            <img v-bind:alt="book.alt" :src="book.img">
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title active>{{ book.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer class="settings-drawer" temporary hide-overlay clipped v-model="drawerRight" right enable-resize-watcher touchless>
      <v-list>
        <settings></settings>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer class="mini-bar" v-model="buyBar" mini-variant enable-resize-watcher touchless>
      <v-list :ripple="false">Shop:
        <v-list-tile v-for="buy in buys" v-bind:href="buy.url" :key="buy.title" v-on:click="buyClick(buy.url)" target="_blank">
          <img v-bind:alt="buy.alt" :src="buy.img" />
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar class="main-menu" fixed persistent>
      <v-btn flat class="main-menu-button" @click.native.stop="drawer = !drawer, info = false, buyMenu = false, socialMenu = false, drawerRight = false, otherBooks = false" :ripple="false">
        <v-icon>ion-navicon</v-icon>
      </v-btn>

      <v-btn v-if="books.length > 0" flat class="otherBooks-button" @click.native.stop="otherBooks = !otherBooks, info = false, buyMenu = false, socialMenu = false, drawerRight = false, drawer = false" :ripple="false"  :key="booksChanged">
        <v-icon>ion-ios-browsers-outline</v-icon>
      </v-btn>
      
      <v-toolbar class="desktop-social-btn" style="margin-left:5%">
        <v-btn flat v-for="social in socials" :key="social.title" v-bind:href="social.url" v-on:click="shareClick(social.title)" target="_blank" :ripple="false">
          <v-icon>{{ social.icon }}</v-icon>
        </v-btn>
      </v-toolbar>
      <v-btn flat class="mobile-buy-btn" @click.native.stop="buyMenu = !buyMenu, info = false, drawer = false, socialMenu = false, drawerRight = false, otherBooks = false">
        <v-icon>ion-bag</v-icon>
      </v-btn>
      <v-navigation-drawer class="buy-menu" width="100vw" height="auto" hide-overlay temporary clipped v-model="buyMenu" @click.stop="buyMenu = !buyMenu" disable-route-watcher touchless>
        <v-list>
          <span>Purchase this book: </span>
            <v-list-tile v-for="buy in buys" :key="buy.title" v-bind:href="buy.url" v-on:click="buyClick(buy.url)" target="_blank">
            <v-list-tile-action>
              <img v-bind:alt="buy.alt" :src="buy.img" />
            </v-list-tile-action>
            <v-list-tile-title v-html="buy.title"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-btn flat class="mobile-social-btn" @click.native.stop="socialMenu = !socialMenu, info = false, buyMenu = false, drawer = false, drawerRight = false, otherBooks = false">
        <v-icon>ion-android-share-alt</v-icon>
      </v-btn>
      <v-navigation-drawer class="social-menu" width="100vw" height="auto" hide-overlay temporary clipped v-model="socialMenu" @click.stop="socialMenu = !socialMenu" disable-route-watcher persistent touchless>
      <v-list>
          <span>Share this book: </span>
          <v-list-tile v-for="social in socials" :key="social.title" v-bind:href="social.url" v-on:click="shareClick(social.title)" target="_blank">
            <v-list-tile-action>
                <v-icon >{{ social.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title v-html="social.title"></v-list-tile-title>
          </v-list-tile>
        </v-list>
        </v-navigation-drawer>
      <v-spacer></v-spacer>
      <v-btn flat class="info-btn" @click.native.stop="info = !info, drawer = false, buyMenu = false, socialMenu = false, drawerRight = false" :ripple="false">
        <v-icon>ion-ios-information-outline</v-icon>
      </v-btn>
      <v-btn flat class="settings-button" @click.native.stop="drawerRight = !drawerRight, info = false, buyMenu = false, socialMenu = false, drawer = false, otherBooks = false" :ripple="false">
        <v-icon>ion-ios-gear-outline</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid>
      <reader></reader>
    </v-container>
  </v-app>
</template>

<script>
import Reader from "./components/Reader.vue";
import Settings from "./components/Settings.vue";
import eventHub from "./event-hub.js";
import axios from 'axios';

export default {
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [
      ],
      booksChanged:'',
      socials: [
        {
          title: "LinkedIn",
          img: "static/img/linkedin-logo.svg",
          url:"https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/1APT7th/%3F1724535441590&title=Jascha%20Heifetz%2C%20Russian%20Music%20Studies&summary=Get%20%23Free%20%23Sample%20of%20Jascha%20Heifetz%2C%20Russian%20Music%20Studies%20-%20%0D%0ANotoriously%20reticent%20about%20his%20early%20years%2C%20violinist%20Jascha%20Heifetz%20famously%20reduced%20the%20story%20of%20his%20childhood%20to%20%22Born%20in%20Russia.%20First%20lessons%20at%203.%20Debut%20in%20Russia%20at%207.%20Debut%20in...&source=LinkedIn",
          icon: "ion-social-linkedin"
        },
        {
          title: "Facebook",
          img: "static/img/facebook-logo.svg",
          url:"https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/1APT7th/%3F1724535441590",
          icon: "ion-social-facebook"
        },
        {
          title: "Twitter",
          img: "static/img/twitter-logo-silhouette.svg",
          url:
            "https://twitter.com/intent/tweet?text=Get%20%23Free%20%23Sample%20of%20Jascha%20Heifetz%2C%20Russian%20Music%20Studies%20%0Dhttps://textcafe.co/books/1APT7th/%3F1724535441590&amp;via=textcafecom",
          icon: "ion-social-twitter"
        },
        {
          title: "Tumblr",
          img: "static/img/tumblr-letter-logo.svg",
          url:
            "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/1APT7th/%3F1724535441590&posttype=link&caption=Get%20%23Free%20%23Sample%20of%20Jascha%20Heifetz%2C%20Russian%20Music%20Studies%20-%20%0D%0ANotoriously%20reticent%20about%20his%20early%20years%2C%20violinist%20Jascha%20Heifetz%20famously%20reduced%20the%20story%20of%20his%20childhood%20to%20%22Born%20in%20Russia.%20First%20lessons%20at%203.%20Debut%20in%20Russia%20at%207.%20Debut%20in...",
          icon: "ion-social-tumblr"
        },
        {
          title: "Pinterest",
          img: "static/img/pinterest-logo.svg",
          url:
            "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/1APT7th/%3F1724535441590&description=Get%20%23Free%20%23Sample%20of%20Jascha%20Heifetz%2C%20Russian%20Music%20Studies%20-%20%0D%0ANotoriously%20reticent%20about%20his%20early%20years%2C%20violinist%20Jascha%20Heifetz%20famously%20reduced%20the%20story%20of%20his%20childhood%20to%20%22Born%20in%20Russia.%20First%20lessons%20at%203.%20Debut%20in%20Russia%20at%207.%20Debut%20in...&media=https://textcafe.co/books/1APT7th/tc-custom/9780253010896.jpg",
          icon: "ion-social-pinterest"
        }
      ],
      buys: [
        { 
          title: 'Amazon US', 
          img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg', 
          url: 'https://www.amazon.com/s?k=9780253010896&i=stripbooks&linkCode=qs&tag=mobilebookcom-20', 
          alt : 'None' 
        },
        { 
          title: 'Google Play', 
          img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg', 
          url: 'https://play.google.com/store/books/details?id=NfMiAQAAQBAJ&amp;rdid=book-NfMiAQAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us', 
          alt : 'None' 
        },
      ],
      right: null,
      left: null
    };
  },
  mounted () {
    axios
      .get('https://www.textcafe.com/widget/get-samples.json?related=9780253010896')
      .then(response => (
        this.books = response.data.map((item) => {
          return {
            title: item.title,
            img: item.coverImagePath,
            url: item.socialUrl,
            alt: "This image is the cover for the book " + item.title
          };
        })
      ))
      .catch(error => (
        // handle error
        console.log(error)
      ))
  },
  created: function() {
    this.$router.options.routes.forEach(route => {
      this.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/1APT7th/tc-custom/9780253010896.jpg?1724535441590',
        alt: 'Jascha Heifetz, Russian Music Studies'
      });
    });
    eventHub.$on("pageNum", newValue => {
      this.pageNum = newValue;
    });
    eventHub.$on("ttlPages", newValue => {
      this.ttlPages = newValue;
    });
  },
  watch: {
    $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },
    iSize: newValue => {
      eventHub.$emit("iSizeChanged", newValue);
    },
    books : newValue => {
      eventHub.$emit("booksChanged",Date.now())
    }
  },
  methods: {
    resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url,
        // eventValue: 123
      })
    },
    shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network,
        // eventValue: 123
      })
    }
  },
  components: {
    settings: Settings,
    reader: Reader
  }
};
</script>

<style lang="stylus">
@import '../../node_modules/vuetify/src/stylus/main';
</style>

<style lang="sass" src="../static/style.sass"></style>

<style lang="sass">

.pager
  position: absolute
  left: 50%
  top: 0
  padding: 7px 10px 7px 20px
  z-index: 20 !important
  transform: translate(-100%, 0)
  background-color: #f3f3f3 !important
  box-shadow: none
  font-size: 12px
  @media screen and (max-width:768px)
    top: auto
    left: 0
    bottom: 0
    transform: translate(0)
  span.badge
    // color: #4BACB8
    color: #f3f3f3
    font-size: 18px
    text-align: center !important
    padding: 0 10px
    &:after
      // display: none
      content: ''
      width: 35px
      height: 30px
      background-color: transparentize(#4BACB8, .5)
      z-index: -1
      left: 2px
      top: -4px
      border-radius: 2px
.pager2
  position: absolute
  left: 50%
  top: 0
  padding: 7px 20px 7px 10px
  z-index: 20 !important
  background-color: #f3f3f3 !important
  box-shadow: none
  font-size: 12px
  @media screen and (max-width:768px)
    top: auto
    left: auto
    right: 0
    bottom: 0
    transform: translate(0)
  span.badge
    // color: #4BACB8
    color: #f3f3f3
    font-size: 18px
    text-align: center !important
    padding: 0 10px
    &:after
      // display: none
      content: ''
      width: 35px
      height: 30px
      background-color: transparentize(#4BACB8, .5)
      z-index: -1
      left: 2px
      top: -4px
      border-radius: 2px
</style>




// WEBPACK FOOTER //
// App.vue?6e4a3b2b